class DeploymentConfigSubsection {
    constructor(
        id,
        value,
        type,
        hasInclusionToggle,
        label,
    ) {
        this.id = id
        this.value = value
        this.type = type
        this.hasInclusionToggle = hasInclusionToggle
        this.label = label
    }
}

export default DeploymentConfigSubsection;